<template>
    <div>
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="5. Capacitate solicitant"></CFTitle>
        <validation-observer #default="{ invalid }" ref="capacitate_solicitant">
            <span class="display-none">{{ invalid }}</span>
            <div class="mt-5">
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="3"
                    content-cols-lg="9"
                    label="Sursa de cofinanțare"
                    class="has-icon custom-responsive"
                >
                    <b-form-input
                        v-model="form.funding_source"
                        type="text"
                        readonly
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    id="fieldset-horizontal"
                    label-cols-lg="3"
                    content-cols-lg="9"
                    label="Alegeți cod CAEN relevant"
                    class="has-icon custom-responsive"
                >
                    <b-form-input
                        v-model="form.caen"
                        type="text"
                        readonly
                    ></b-form-input>
                    <b-icon-info-circle-fill id="info-icon" class="info-icon"></b-icon-info-circle-fill>
                    <b-tooltip target="info-icon" triggers="hover" placement="left">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/proiectul-meu">Proiectul meu</router-link></b-tooltip>
                </b-form-group>
                <div class="mt-4">
                    <M3Warn type="yellow" text="<strong>Capacitatea administrativă</strong> (vă rugăm să menționați după caz,  documente de înființare, acționari, existența unor mecanisme instituționale precum unitatea de implementare a proiectului (UIP) capabilă să implementeze și să deruleze proiectul și, dacă este posibil, includeți organigrama propusă pentru implementarea și derularea proiectului)." ></M3Warn>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                        <CFTextarea v-model="form.administrative_capacity" :read-only="completed" :limit="1750"></CFTextarea>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
                <div class="mt-4">
                    <M3Warn type="yellow" text="<strong>Capacitatea financiară</strong> (vă rugăm să confirmați capacitatea financiară a organismului responsabil pentru implementarea proiectului, pentru a demonstra că acesta este în măsură să garanteze lichiditățile necesare pentru o finanțare adecvată a proiectului, astfel încât să se asigure implementarea cu succes a acestuia și funcționarea în viitor, în plus față de celelalte activități ale organismului)" ></M3Warn>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                        <CFTextarea v-model="form.financial_capacity" :read-only="completed" :limit="1750"></CFTextarea>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
                <div class="mt-4">
                    <M3Warn type="yellow" text="<strong>Capacitatea tehnică</strong> (vă rugăm să furnizați cel puțin un rezumat al expertizei necesare pentru implementarea proiectului și să precizați numărul persoanelor cu o astfel de expertiză disponibile în cadrul organizației și alocate proiectului)Se va descrie succint solicitantul (personalul angajat, servicii oferite, alte informații relevante)" ></M3Warn>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                        <CFTextarea v-model="form.tehnical_capacity" :read-only="completed" :limit="1750"></CFTextarea>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
                <div class="mt-4">
                    <M3Warn type="yellow" text="<strong>Capacitatea juridică</strong> (indicați statutul juridic al beneficiarului (solicitantului) care permite implementarea proiectului, precum și capacitatea sa de a întreprinde acțiuni legale, dacă este necesar)." ></M3Warn>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                        <CFTextarea v-model="form.legal_capacity" :read-only="completed" :limit="1750"></CFTextarea>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </div>
            </div>
        </validation-observer>
        <hr class="mt-4">

        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>

</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip } from "bootstrap-vue";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import CFTextarea from "./CFTextarea";
    import _ from "lodash";
    require('@/helpers/validations/validations');
    export default {
        components: {
            CFTitle,
            CFTextarea,
            M3Warn,
            BFormInput, BFormGroup, BFormCheckbox, BIconInfoCircleFill, BTooltip,
            ValidationProvider, ValidationObserver
        },
        props: {
            m3GrantApplication: null,
            termeneV1: null,
            termeneV2: null,
            termeneV3: null,
            indicators: null,
            data: null
        },
        data() {
            return {
                completed: false,
                form: {
                    funding_source: 'Contribuție privată',
                    caen: '',
                    administrative_capacity: '',
                    financial_capacity: '',
                    tehnical_capacity: '',
                    legal_capacity: '',
                }
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            data: {
                handler: function() {
                    this.getFormData()
                },
                deep: true
            },
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Capacitate solicitant')) {
                        this.completed = true
                        this.$store.dispatch('finantare/addToProgress', 'Capacitate solicitant')
                    }
                },
                deep: true
            },
            termenev2: {
                handler() {
                    if(this.m3GrantApplication && !this.m3GrantApplication.capacitate_solicitant) {
                        this.getFormData()
                    }
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.capacitate_solicitant){
                        this.form.administrative_capacity = this.m3GrantApplication.capacitate_solicitant.administrative_capacity;
                        this.form.financial_capacity = this.m3GrantApplication.capacitate_solicitant.financial_capacity;
                        this.form.tehnical_capacity = this.m3GrantApplication.capacitate_solicitant.tehnical_capacity;
                        this.form.legal_capacity = this.m3GrantApplication.capacitate_solicitant.legal_capacity;
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.getFormData()
            if(this.m3GrantApplication && this.m3GrantApplication.capacitate_solicitant){
                this.form.administrative_capacity = this.m3GrantApplication.capacitate_solicitant.administrative_capacity;
                this.form.financial_capacity = this.m3GrantApplication.capacitate_solicitant.financial_capacity;
                this.form.tehnical_capacity = this.m3GrantApplication.capacitate_solicitant.tehnical_capacity;
                this.form.legal_capacity = this.m3GrantApplication.capacitate_solicitant.legal_capacity;
            }
            if(this.finantareProgress && this.finantareProgress.includes('Capacitate solicitant')) {
                this.completed = true
                this.$store.dispatch('finantare/addToProgress', 'Capacitate solicitant')
            }
        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            getFormData() {
                if(this.data) {
                    this.form.caen = this.data && this.data.m3_project ? (this.data.m3_project.secondary_caen ? this.data.m3_project.secondary_caen : this.data.m3_project.caen) : ''
                    let associates = []
                    this.data.associates.forEach(asociat => {
                        associates.push(asociat.name)
                    })
                    this.form.administrative_capacity = 'Întreprinderea  '+ JSON.parse(localStorage.getItem('currentM3Company')).name +', având ca acționari '+ associates +', activează de '+ this.termeneV3.vechime +' ani în domeniul ____________________. Principalele produse pe care  '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' le livrează/servicii pe care le  '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' le prestează sunt ___________. \n' +
                        ''+ JSON.parse(localStorage.getItem('currentM3Company')).name +'  dispune de resursele materiale și umane adaptate dimensiunii proiectului propus.\n' +
                        '\n' +
                        'Solicitantul prevede înființarea unei unități de implementare a proiectului (UIP) capabilă să implementeze și să deruleze proiectul pentru a asigura îndeplinirea obiectivelor stabilite.\n' +
                        '\n' +
                        'Sau\n' +
                        '\n' +
                        'Solicitantul va apela la servicii de consultanță în scopul elaborării documentaţiei de atribuire şi/sau aplicării procedurilor de atribuire a contractelor de achiziţie publică și pentru a asigura managementul proiectului. \n'

                    this.form.financial_capacity = 'Solicitantul poate susține '+ this.termeneV2.cofinancing +'% din valoarea eligibilă a finanțării. Deasemenea solicitantul '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' deține capacitatea financiară de a susține din fonduri proprii cheltuielile neeligibile în valoare totală de '+ (this.indicators ? this.indicators.cheltuieli_neeligibile.RON : '-') +' lei, reprezentând '+ (this.indicators ? this.indicators.cheltuieli_neeligibile.procent : '-') +' % din valoarea totală a proiectului. Deasemenea '+ JSON.parse(localStorage.getItem('currentM3Company')).name +'  va susține din fonduri proprii cheltuielile privind asigurarea unui responsabil protecție date (GDPR), cheltuieli cu auditul final, precum și alte cheltuieli neprevăzute aferente unor activități eligibile. \n' +
                        '\n' +
                        'Departamentul contabil al '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' regulile monografiei contabile și fiscală cu privire la formele de finanțare nerambursabilă. Sumele provenite din ajutorul de stat vor fi înregistrate în contabilitate urmând regimul subvențiilor prevăzut la pct. 392-404 din Reglementările contabile privind situațiile financiare anuale individuale și situațiile financiare anuale consolidate, aprobate prin OMFP 1802/2014. Se vor utiliza mecanismele de finanțare (prefinanțare, plată, rambursare) stabilite prin Ordonanța de urgență a Guvernului nr. 40/2015 privind gestionarea financiară a fondurilor europene pentru perioada de programare 2014-2020, cu modificările și completările ulterioare și Hotărârea Guvernului nr. 93/2016 pentru aprobarea Normelor metodologice de aplicare a prevederilor Ordonanței de urgență a Guvernului nr. 40/2015 privind gestionarea financiară a fondurilor europene pentru perioada de programare 2014-2020, cu modificările și completările ulterioare.\n'

                    this.form.tehnical_capacity = 'Solicitantul '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' are expertiză în activitățile propuse în cadrul proiectului prin resursele umane din cadrul întreprinderii. Managerul de proiect va avea funcția de monitorizare și control asupra activităților, va monitoriza derularea achizițiilor conform reglementărilor în vigoare și se va asigura de atingerea rezultatelor și indicatorilor la termenele stabilite. Managerul de proiect are o experiență de _____ ani în implementarea de proiecte/management al afacerilor. \n' +
                        '\n' +
                        'Departamentul de contabilitate al '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' va colabora strâns cu expertul financiar desemnat în UIP pentru a elabora și depune cererile de prefinanțare, de rambursare și de plată, pentru a răspunde la eventuale solicitări de clarificări privind cheltuielile efectuate.\n' +
                        '\n' +
                        'Sau\n' +
                        '\n' +
                        'Solicitantul colaborează cu o firmă specializată în consultanță pentru a asigura managementul proiectului, pentru a elabora și depune cererile de prefinanțare, de rambursare și de plată, pentru a răspunde la eventuale solicitări de clarificări privind cheltuielile efectuate. \n' +
                        '\n' +
                        '\n' +
                        'Pentru activitatea de publicitate și informare, '+ JSON.parse(localStorage.getItem('currentM3Company')).name +' va desemna un expert care va asigura respectarea prevederilor contractului de finanțare privind această categorie de cheltuieli eligibile. \n'

                    let enterpriseType = ''
                    if(this.data.enterprise_type === 1){
                        enterpriseType = 'autonomă'
                    } else if(this.data.enterprise_type === 2){
                        enterpriseType = 'parteneră'
                    } else{
                        enterpriseType = 'legată'
                    }
                    let bilant2019 = []
                    let angajati2019 = ''
                    if (this.termeneV3 && this.termeneV3.bilant_scurt && this.termeneV3.bilant_scurt.length > 0) {
                        bilant2019 = _.filter(this.termeneV3.bilant_scurt, v => v.an === 2019);
                        if(this.data && this.data.m3_project && this.data.m3_project.indicators && this.data.m3_project.indicators.indicators && this.data.m3_project.indicators.indicators.employees && this.data.m3_project.indicators.indicators.employees.number2019) {
                            angajati2019 = this.data.m3_project.indicators.indicators.employees.number2019
                        } else {
                            angajati2019 = bilant2019[0].numar_mediu_angajati ? bilant2019[0].numar_mediu_angajati : 0
                        }
                    }
                    let stateAids = ''
                    if(this.data.m3_project && this.data.m3_project.state_aids){
                        let stateAidsHelp = 0
                        stateAidsHelp = Number(this.data.m3_project.state_aids.help_moneyM1 ? this.data.m3_project.state_aids.help_moneyM1 : 0) +  Number(this.data.m3_project.state_aids.help_moneyM2 ? this.data.m3_project.state_aids.help_moneyM2 : 0) +  Number(this.data.m3_project.state_aids.help_moneyHoreca ? this.data.m3_project.state_aids.help_moneyHoreca : 0) +  Number(this.data.m3_project.state_aids.help_moneyIMM ? this.data.m3_project.state_aids.help_moneyIMM : 0)
                        stateAids = 'a beneficiat de ajutoare de stat din surse locale, naționale, comunitare sau din alte surse în cuantum de '+ stateAidsHelp +'.'
                    } else {
                        stateAids = 'nu a mai beneficiat de ajutoare de stat din surse locale, naționale, comunitare sau din alte surse'
                    }
                    this.form.legal_capacity = ''+ JSON.parse(localStorage.getItem('currentM3Company')).name +' este o întreprindere '+ enterpriseType +' care se încadrează în categoria IMM, având o cifră de afaceri de in anul 2019 de '+ this.termeneV1.CA_2019 +' lei și un număr mediu anual de angajați de '+ angajati2019 +'. Solicitantul nu este în vreuna dintre situațiile de faliment/lichidare, nu a fost entitate în dificultate în anul 2019, '+ stateAids +'\n' +
                        '\n' +
                        ''+ JSON.parse(localStorage.getItem('currentM3Company')).name +' nu finanțează activități de export. \n' +
                        '\n' +
                        'Echipa de implementare are expertiza necesară monitorizării modului în care se derulează contractele de achiziții și de a soluționa eventuale litigii prin departamentul juridic intern/colaborare cu o firmă de consultanță legală/de avocatură.\n'
                }
            },
            sendForm(){
                if(this.completed){
                    this.$refs.capacitate_solicitant.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {capacitate_solicitant: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Capacitate solicitant')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Capacitate solicitant')
                }
            }
        }
    }
</script>

<style scoped>
.info-icon{
    position: absolute;
    right: 15px;
    top: 0;
    margin: auto 0;
    bottom: 0;
}
.has-icon{
    position: relative;
}
</style>
